export default "__VITE_ASSET__BVJo0S$Z__"